import { render } from "./App.vue?vue&type=template&id=8bb094ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8bb094ca&lang=css"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__